import React from "react";
import styles from "./PageChrome.module.css";

const TONES = { primary: styles.statPrimary, success: styles.statSuccess, danger: styles.statDanger, neutral: "" };

// Summary card above a table: a label, a big value and one line of context, optionally led by an up/down change pill.
export default function StatCard({ label, value, sub, tone = "neutral", delta = null }) {
  return (
    <div className={`${styles.statCard} ${TONES[tone] || ""}`}>
      <span className={styles.statLabel}>{label}</span>
      <span className={styles.statValue}>{value}</span>
      {delta && <span className={`${styles.statDelta} ${delta.up ? styles.statDeltaUp : styles.statDeltaDown}`}>{delta.text}</span>}
      {sub && <span className={styles.statSub}>{sub}</span>}
    </div>
  );
}
